import * as React from 'react'

import createContext from 'modules/core/hooks/createContext'
import { useCallback } from 'modules/core/hooks/useCallback'

import type { UIDispatch } from './reducers/ui'
import UIReducer, { UIState, initialUiState } from './reducers/ui'

type Context = [UIState, UIDispatch]

const { context: UIContext, hook: useUI } = createContext<Context>()

const UIProvider = ({ children }: React.PropsWithChildren) => {
  const memoizedReducer = useCallback(UIReducer, [])
  const [state, dispatch] = React.useReducer(memoizedReducer, initialUiState())

  return <UIContext.Provider value={[state, dispatch]}>{children}</UIContext.Provider>
}

export { UIProvider, useUI }
